"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
var _selPlat = _interopRequireDefault(require("@/components/selPlat"));
var _jszip = _interopRequireDefault(require("jszip"));
var _fileSaver = _interopRequireDefault(require("file-saver"));
var _xlsx = _interopRequireDefault(require("xlsx"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'qrcode',
  components: {
    drawer: _filter.default,
    Pagination: _Pagination.default,
    selPlat: _selPlat.default
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.state.user.deviceNameObj;
    }
  },
  data: function data() {
    var _this = this;
    return {
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.endTime) {
            return time.getTime() > _this.form.endTime || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.startTime) {
            return time.getTime() < _this.form.startTime || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime() + 86400;
          }
        }
      },
      editVisible: false,
      codeObj: {},
      list: [],
      listLoading: true,
      tableMaxH: '250',
      form: {},
      listQuery: {
        notnull_device_id: '-1',
        status: '-1',
        search_agent_id: '0',
        type: 1,
        page: 1,
        limit: 20,
        total: 10,
        page_num: 1
      },
      son_id: this.$route.query.son_id || '',
      selSnArr: [],
      selSnUrl: [],
      xlsxName: '设备二维码列表',
      outStatus: false,
      excel: false,
      percentage: 0,
      wbout: {},
      wi: 0,
      device: {
        0: 'battery',
        1: 'line',
        '1b': 'bluetooth',
        '1c': 'bluetooth',
        2: 'pillow',
        3: 'charge',
        4: 'wash',
        6: 'cfj'
      },
      agent_name: {},
      deviceList: {}
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'edit') {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },
  activated: function activated() {
    if (!this.$route.meta.isBack || !this.list) {
      this.getList();
      this.getDeviceList();
    }
  },
  mounted: function mounted(options) {},
  methods: {
    /**
     * 获取设备类型
     */
    getDeviceList: function getDeviceList() {
      var _this2 = this;
      this.$get('agentapi/goods/goods_detail_types', {
        limit: 1000
      }).then(function (res) {
        var obj = {};
        res.list.map(function (item) {
          obj[item.code_tag] = item;
        });
        _this2.deviceList = obj;
      });
    },
    /**
     * 筛选
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.page = 1;
      } else {
        this.listQuery.page = 1;
      }
      this.getList();
    },
    /**
     * 校验是否可选
     */
    checkSel: function checkSel(row) {
      return !row.agent_id && row.device_id;
    },
    /**
     * 选择设备铺货
     * @param {Object} res
     */
    selSb: function selSb(list) {
      var selSnArr = [],
        selSnUrl = [];
      for (var i in list) {
        selSnArr.push(list[i].code_sn);
        if (list[i].code_url) selSnUrl.push(list[i].code_url);
      }
      this.selSnArr = selSnArr;
      this.selSnUrl = selSnUrl;
    },
    /**
     * 操作
     */
    setEquip: function setEquip(row) {
      var _this3 = this;
      var selSn = this.selSnArr.join(',');
      if (this.son_id) {
        this.$post('agentapi/save_distribute_agent_devices', {
          son_id: this.son_id,
          goods_sn: row ? [row.code_sn] : this.selSnArr
        }).then(function (res) {
          _this3.$message({
            message: '分配成功',
            type: 'success'
          });
          history.back();
        });
      } else {
        this.$router.push({
          path: '/partner/index',
          query: {
            zuo_sn: row ? row.code_sn : selSn
          }
        });
      }
    },
    getList: function getList() {
      var _this4 = this;
      var params = Object.assign({}, this.form, this.listQuery);
      if (params.status == -1) delete params.status;
      if (this.device[params.key_tag]) {
        params.key_tag = this.device[params.key_tag];
      } else {
        delete params.key_tag;
      }
      if (params.startTime) params.startTime = params.startTime / 1000;
      if (params.endTime) params.endTime = params.endTime / 1000;
      this.$get('QRcode/code_list', params).then(function (res) {
        if (_this4.outStatus) {
          _this4.list = res.list;
          if (_this4.listQuery.page >= res.total) {
            _this4.listLoading = false;
            _this4.percentage = 100;
          } else {
            _this4.listQuery.page++;
            _this4.percentage = _this4.percentage < 95 ? _this4.percentage + 5 : 95;
          }
          _this4.$nextTick(function () {
            _this4.outTabdd('table_box', _this4.xlsxName);
          });
        } else {
          _this4.listLoading = false;
          _this4.list = res.list;
        }
        _this4.listQuery.page_num = res.total;
        _this4.agent_name = res.agent_name;
        if (_this4.listQuery.page == 1) _this4.tableMaxH = window.innerHeight - _this4.$refs.table_box.$el.offsetTop - 85;
      }).catch(function () {
        _this4.listLoading = false;
      });
    },
    /**
     * 生成二维码图片
     */
    createImg: function createImg(row) {
      this.$get('QRcode/createCodeSnImage', {
        id: row.id
      }).then(function (res) {
        row.code_url = res.img_url;
      });
    },
    /**
     * 修改二维码
     */
    editCode: function editCode(row) {
      window.codeInfo = row;
      this.$router.push({
        path: "/qrcode/edit?code_sn=".concat(row.code_sn)
      });
    },
    /**
     * 下载二维码
     */
    downloadImg: function downloadImg() {
      var that = this;
      that.downLoad = this.$loading({
        lock: true,
        text: '文件打包下载中，请耐心等待',
        spinner: 'el-icon-loading'
      });
      var blogTitle = '设备二维码';
      var zip = new _jszip.default();
      var imgs = zip.folder(blogTitle);
      var baseList = [];
      var arr = that.selSnUrl; // 要下载图片的url
      var imgNameList = []; // 图片名称
      var _loop = function _loop() {
        var image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute('crossOrigin', 'anonymous');
        image.onload = function () {
          var canvas = document.createElement('canvas');
          canvas.width = image.width;
          canvas.height = image.height;
          var context = canvas.getContext('2d');
          context.drawImage(image, 0, 0, image.width, image.height);
          var url = canvas.toDataURL(); // 得到图片的base64编码数据
          canvas.toDataURL('image/png');
          baseList.push(url.substring(22)); // 去掉base64编码前的 data:image/png;base64,
          imgNameList.push(image.src.substring(image.src.lastIndexOf("/") + 1));
          if (baseList.length === arr.length && baseList.length > 0) {
            for (var k = 0; k < baseList.length; k++) {
              imgs.file(imgNameList[k], baseList[k], {
                base64: true
              });
            }
            zip.generateAsync({
              type: 'blob'
            }).then(function (content) {
              _fileSaver.default.saveAs(content, blogTitle + '.zip');
              that.downLoad.close();
            });
          }
        };
        image.src = arr[i];
      };
      for (var i = 0; i < arr.length; i++) {
        _loop();
      }
    },
    /**
     * 导出
     */
    outTable: function outTable() {
      this.outStatus = true;
      this.listLoading = true;
      this.listQuery.limit = 100;
      this.list = [];
      this.excel = true;
      this.getList();
    },
    /**
     * 导出表格
     */
    outTabdd: function outTabdd(tabId) {
      var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data';
      var fix = document.querySelector('.el-table__fixed-right');
      var xlsxParam = {
        raw: true
      };
      var wb;
      if (fix) {
        this.wbout[this.wi] = _xlsx.default.utils.table_to_book(document.querySelector("#".concat(tabId)).removeChild(fix), xlsxParam);
        document.querySelector("#".concat(tabId)).appendChild(fix);
      } else {
        this.wbout[this.wi] = _xlsx.default.utils.table_to_book(document.querySelector("#".concat(tabId)), xlsxParam);
      }
      this.wi++;
      console.log(0);
      if (this.listLoading) {
        this.getList();
        return;
      }
      var wboutes = this.wbout[0];
      var no = '';
      for (var i in this.wbout) {
        delete this.wbout[i].Sheets.Sheet1['!merges'];
        if (i > 0) {
          var sheet1 = this.wbout[i].Sheets.Sheet1;
          for (var s in sheet1) {
            var k = s.substring(0, 1);
            var n = s.substring(1);
            if (n != 1 && n != 'ref') {
              var _k = s.substring(0, 1);
              n = s.substring(1);
              no = parseInt(i) * 100 + parseInt(n);
              sheet1[_k + no] = sheet1[s];
            }
            delete sheet1[s];
          }
          wboutes.Sheets.Sheet1 = Object.assign(wboutes.Sheets.Sheet1, sheet1);
        }
      }
      if (this.wbout[1]) wboutes.Sheets.Sheet1['!ref'] = "A1:Q".concat(no);
      var wbout = _xlsx.default.write(wboutes, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      });
      this.percentage = 100;
      if (!this.listLoading) {
        try {
          _fileSaver.default.saveAs(new Blob([wbout], {
            type: 'application/octet-stream'
          }), "".concat(fileName, ".xlsx"));
          this.excel = false;
          this.$message({
            message: '导出成功',
            type: 'success'
          });
          setTimeout(function () {
            location.reload();
          }, 1000);
        } catch (e) {
          if (typeof console !== 'undefined') console.log(e, this.wbout);
        }
        return this.wbout;
      }
    },
    showCodeType: function showCodeType(tag, sn) {
      var typeText = '';
      switch (tag) {
        case 'CDX:':
        case 'LINE:':
          typeText = "密码线";
          break;
        case 'B-LINE:':
          typeText = "蓝牙线";
          break;
        case 'NB-LINE:':
          typeText = "密码蓝牙线";
          break;
        case 'CHAZUO:':
          typeText = "电动两轮车插座";
          break;
        case 'XYJ:':
        case 'TAG_4_1':
          typeText = "洗衣机";
          break;
        case 'AMZ:':
        case 'TAG_2_1':
          typeText = "按摩枕";
          break;
        case 'CFJ:':
        case 'TAG_6_1':
          typeText = "电吹风";
          break;
        case 'TAG_7_1':
        case 'TAG_7_6':
          typeText = "套套机";
          break;
        case 'TAG_3_1':
          typeText = "充电桩";
          break;
        default:
          if (sn.indexOf('F') > -1) {
            typeText = "充电桩";
          } else {
            typeText = "充电宝";
          }
          break;
      }
      return typeText;
    }
  }
};